import { useAtomValue } from 'jotai';
import { cloneDeep } from 'lodash-es';
import { useCallback } from 'react';
import { clientInvestmentsStateJ, otherInvestmentsStateJ } from '../../../services/state/CapTableFormStateJ';
import {
  useSyncClientInvestmentDataWithSharesState,
  useSyncOtherInvestmentDataWithSharesState,
} from './useSyncInvestmentDataWithSharesState';

export interface IInvestmentGridRow extends Record<string, unknown> {
  fundId: number | null;
}

export function useInvestmentGridRowData() {
  const clientInvestments = useAtomValue(clientInvestmentsStateJ);
  const syncInvestments = useSyncClientInvestmentDataWithSharesState();

  const getInitialRowData = useCallback((): IInvestmentGridRow[] => {
    return syncInvestments(cloneDeep(clientInvestments));
  }, [clientInvestments, syncInvestments]);

  return { getInitialRowData };
}

export interface IOtherInvestmentsGridRow extends Record<string, unknown> {
  investor: string;
}

export function useOtherInvestmentsRowData() {
  const otherInvestments = useAtomValue(otherInvestmentsStateJ);
  const syncOtherInvestments = useSyncOtherInvestmentDataWithSharesState();

  const getInitialRowData = useCallback((): IOtherInvestmentsGridRow[] => {
    return cloneDeep(syncOtherInvestments(otherInvestments));
  }, [otherInvestments, syncOtherInvestments]);

  return { getInitialRowData };
}
